import React, { useContext, useEffect } from "react";
import Layout from "../Layout";
import { NavLink } from "react-router-dom";
import { LoadContext } from "../App";
import { Helmet } from "react-helmet";

const Accueil = () => {
  const { load } = useContext(LoadContext);
  console.log("Page Accueil");
  console.log(load);

  return (
    <>
      <Helmet>
        <title>Vialle Construction</title>
        <meta
          name="description"
          content="Vialle Construction est une entreprise de construction éco-performante située à Sainte-Adèle qui vous accompagne de l’idée à la réalisation de votre projet. Vous méritez un espace de vie sain et performant"
        />
        <link rel="canonical" href="https://vialleconstruction.ca/" />
        <meta property="og:title" content="Vialle Construction" />
        <meta
          property="og:description"
          content="Vialle Construction est une entreprise de construction éco-performante située à Sainte-Adèle qui vous accompagne de l’idée à la réalisation de votre projet. Vous méritez un espace de vie sain et performant"
        />
        <meta property="og:url" content="https://vialleconstruction.ca/" />
        <meta
          property="og:image"
          content="https://vialleconstruction.ca/assets/logo.png"
        />
      </Helmet>
      <Layout>
        <div className="accueilPage">
          <img
            src="./assets/miniature/home.webp"
            alt="fond d'écran"
            style={{ display: "none" }}
          />
          <main style={load ? { display: "flex" } : { display: "none" }}>
            <h1>votre vision, notre expertise ! </h1>
            <p>
              Notre philosophie : Un bâtiment sain et performant ou rien !{" "}
              <span>Vialle Construction</span> vous accompagne de l’idée à la
              réalisation de votre projet. Vous méritez un espace de vie sain et
              performant.
            </p>
            <div className="buttons">
              <NavLink to={"/Ensavoirplus"}>
                <button className="btn-savoir">En savoir plus</button>
              </NavLink>
              <NavLink to={"/Realisations"}>
                <button className="btn-projet">Nos projets</button>
              </NavLink>
            </div>
          </main>
        </div>
      </Layout>
    </>
  );
};

export default Accueil;
